export function sortByNameAlphabetically(a, b) {
    return a.name.localeCompare(b.name, undefined, {
        numeric: true,
        sensitivity: 'base',
    });
}
export function getCaseInsensitiveStringMatch(...strings) {
    if (strings.length === 0)
        return true;
    const normalized = strings[0].toLowerCase();
    return strings.every((str) => str.toLowerCase() === normalized);
}
export function prepareForCaseChange(str) {
    return (str
        // lowercase all letters in the string
        .toLocaleLowerCase()
        // replace all punctuation with spaces
        .replace(/([^\w\d\s]|_)/g, ' ')
        // replace repeated spaces with a single space
        .replace(/\s+/g, ' ')
        // remove leading and trailing spaces
        .trim());
}
export function convertToCamelCase(str) {
    return (prepareForCaseChange(str)
        // split the string up along any spaces
        .split(' ')
        // in every word after the first make the first letter uppercase
        .map((word, idx) => {
        const letters = word.split('');
        if (idx !== 0) {
            letters[0] = letters[0].toLocaleUpperCase();
        }
        return letters.join('');
    })
        // rejoin all words into a single string
        .join(''));
}
export function convertToKebabCase(str) {
    return (prepareForCaseChange(str)
        // replace all spaces with hyphens
        .replace(/\s+/g, '-'));
}
export function convertToSnakeCase(str) {
    return (prepareForCaseChange(str)
        // replace all spaces with underscores
        .replace(/\s+/g, '_'));
}
export function capitalizeFirstLetter(str) {
    const trimmed = str.trimStart();
    return !trimmed ? str : trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}
export function isValidEmail(str) {
    return !!str.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
}
export function decodeHTMLEntities(text) {
    let textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}
/**
 * Takes up to the first X characters of a string, returning
 * a truncated version of the string with an ellipses at the end.
 */
export function truncateWithEllipsis(input, characterLimit) {
    if (input.length <= characterLimit || characterLimit < 3) {
        return input;
    }
    //trimEnd is used to remove trailing white space at end of input
    return input.slice(0, characterLimit - 3).trimEnd() + '...';
}
/**
 * Given an array of strings `getUniqueStrings` returns a new array
 * consisting only of unique strings from the original array
 * @param arr
 */
export function getUniqueStrings(arr) {
    return Array.from(new Set(arr));
}
export const sanitizeMaskedCurrencyValue = (value) => {
    if (!value || value === 'null') {
        return '0';
    }
    // returns a currency value with any commas stripped out
    return value.toString().replace(/,/g, '');
};
